import React from 'react'
import style from './CardSkill.module.scss';

const CardSkill = ({ data, text, animacion, duration, image, position }) => {
    return (
        <div
            data-aos={animacion}
            data-aos-duration={duration}
            className={style.container}
            style={{backgroundImage: `url(${image})`, backgroundPosition: `${position}` }}
        >
            <div className={style.container__wrapper}>
                <h4>{text}</h4>
                <div className={style.container__wrapper__content}>
                    {
                        data.map((p, i) => {
                            return (
                                <div className={style.container__wrapper__content__group} key={i}>
                                    {p.logo}
                                    <p>{p.name}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default CardSkill